var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 11.9264C12.4695 11.9264 14.0665 10.3295 14.0665 8.35951C14.0665 6.38956 12.4695 4.7926 10.4996 4.7926C8.52964 4.7926 6.93268 6.38956 6.93268 8.35951C6.93268 10.3295 8.52964 11.9264 10.4996 11.9264Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.925 6.65258C17.8106 3.90691 13.9907 1.07349 10.4996 1.07349C7.0085 1.07349 3.18943 3.90691 1.07501 6.65258",
    stroke: "#D0D5DD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLightGray);
export default __webpack_public_path__ + "static/media/eye-light-gray.8ac1be6103235fa57640d83db09e4d28.svg";
export { ForwardRef as ReactComponent };